// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1385":"77b369ec","2589":"d6fdf0fb","4098":"3668d1b7"}[chunkId] + ".css";
};